<!-- <h2 fxLayoutAlign="center center"
    mat-dialog-title
    translate="performance.labels.profileCampaignInfo"></h2> -->

<div
  class="profileCampaignInfo"
  fxLayout="column"
  fxLayoutGap="12px"
  fxLayoutAlign="space-between center"
>
<!-- <img src="assets/images/icon/sepet-logo.png"> -->

  <mat-dialog-content>
    <div [innerHTML]="profileCampaignInfoDescription"></div>
  </mat-dialog-content>
</div>
<mat-dialog-actions align="end">
  <button
    mat-button
    mat-dialog-close
    cdkFocusInitial
    translate="shared.labels.close"
  ></button>
</mat-dialog-actions>
